<template>
    <b-card v-if="account" title="Account Info" class="h-100">
        <b-table
            id="account-info-table"
            class="mb-0"
            small
            stacked
            :fields="fields"
            :items="items"
        >
            <template #cell(created_at)="data">
                <DateDisplay :value="data.value"/>
            </template>
        </b-table>
    </b-card>
</template>

<script>
    import { mapState } from 'vuex'
    import DateDisplay from '%/components/Admin/ui/DateDisplay'

    export default {
        name: 'AccountInfo',
        components: {
            DateDisplay,
        },
        computed: {
            ...mapState({
                account: state => state.account.account,
            }),
            fields() {
                return [
                    {
                        key: 'id',
                        label: 'ID',
                    },
                    {
                        key: 'name',
                        label: 'Name',
                    },
                    {
                        key: 'code',
                        label: 'Code',
                    },
                    {
                        key: 'created_at',
                        label: 'Created',
                    },
                ]
            },
            items() {
                return [
                    this.account,
                ]
            },
        },
    }
</script>

<style lang="scss">
    #account-info-table tbody > tr > :first-child {
        border-top-width: 1px !important;
    }
    #account-info-table {
        border-bottom: 1px solid $gray-200;
    }
</style>
